<form [formGroup]="form" (ngSubmit)="onFormSubmit()" fxLayout="column" fxFlex="1 0 auto">
  <div fxLayout="row" fxFlex="1 1 auto" class="neq-page-wrapper">
    <div class="neq-container" fxLayout="column" fxFlex>
      <mat-form-field>
        <mat-select formControlName="nbRowByPage" [placeholder]="'label.user.preferences.nb-row-by-page' | translate"
                    required>
          <mat-option *ngFor="let elt of arrayNbRowByPage" [value]="elt">{{ elt }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.nbRowByPage.errors?.required">
          {{ 'error.common.field-required' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-select formControlName="nbTableResult"
                    [placeholder]="'label.user.preferences.nb-table-result' | translate" required>
          <mat-option *ngFor="let elt of arrayNbTableResult" [value]="elt">{{ elt }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.nbTableResult.errors?.required">
          {{ 'error.common.field-required' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-checkbox formControlName="resultShowUnit" class="mat-form-field">
        {{'label.user.preferences.result-show-unit' | translate }}
      </mat-checkbox>
      <mat-form-field>
        <input select-all matInput [placeholder]="'label.user.preferences.result-tolerance-percent' | translate"
               formControlName="resultTolerancePercent"
               required>
        <mat-error *ngIf="form.controls.resultTolerancePercent.errors?.pattern">
          {{'error.common.numeric.int.positive' | translate}}
        </mat-error>
      </mat-form-field>
    </div>

    <aside>
      <div fxLayoutAlign="end center" class="neq-action-button">
        <button pButton 
          [disabled]="form.pristine"
          class="neq-primeng-button primeng-flat"
          [matTooltip]="'msg.common.icon.save' | translate"
          type="submit"
        >
          <neq-icon svgIcon="enregistrer"></neq-icon>
        </button>
      </div>
    </aside>
  </div>
</form>
